(function () {
    angular.module('app', []);    
})();